import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';
import './Header.css';

const navItems = [
    {
        view: 'vigilanciaEntomologica', label: 'Formulários de Campo',
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/>
                <rect x="9" y="3" width="6" height="4" rx="1"/>
                <line x1="9" y1="12" x2="15" y2="12"/><line x1="9" y1="16" x2="13" y2="16"/>
            </svg>
        ),
    },
    {
        view: 'exames', label: 'Exames',
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8l-5-5z"/>
                <polyline points="9 3 9 8 14 8"/><line x1="12" y1="12" x2="12" y2="17"/><line x1="9.5" y1="14.5" x2="14.5" y2="14.5"/>
            </svg>
        ),
    },
    {
        view: 'borrifacao', label: 'Relatório de Borrifação',
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <polyline points="12 6 12 12 16 14"/>
            </svg>
        ),
    },
    {
        view: 'localidades', label: 'Localidades',
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                <circle cx="12" cy="10" r="3"/>
            </svg>
        ),
    },
    {
        view: 'mapa', label: 'Mapa de Vigilância',
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"/>
                <line x1="9" y1="3" x2="9" y2="18"/><line x1="15" y1="6" x2="15" y2="21"/>
            </svg>
        ),
    },
    {
        view: 'vigilancia_passiva', label: 'Vigilância Passiva',
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/>
                <line x1="4" y1="22" x2="4" y2="15"/>
            </svg>
        ),
    },
    {
        view: 'gerenciamento', label: 'Agentes',
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
        ),
    },
];

const VIEW_ROUTES = {
    vigilanciaEntomologica: '/formularios',
    exames:                 '/exames',
    borrifacao:             '/borrifacao',
    localidades:            '/localidades',
    mapa:                   '/mapa',
    vigilancia_passiva:     '/vigilancia-passiva',
    gerenciamento:          '/agentes',
};

const COLLAPSE_KEY = 'sidebar_collapsed';

const Sidebar = ({ activeView }) => {
    const [municipioNome, setMunicipioNome] = useState('');
    const [isMobileOpen, setIsMobileOpen] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(
        () => window.innerWidth <= 768 ? true : localStorage.getItem(COLLAPSE_KEY) === 'true'
    );
    const navigate = useNavigate();

    useEffect(() => {
        const storedName = localStorage.getItem('user_municipio_nome');
        if (storedName) setMunicipioNome(storedName);
    }, []);

    useEffect(() => {
        document.body.classList.toggle('sidebar-collapsed', isCollapsed);
        return () => document.body.classList.remove('sidebar-collapsed');
    }, [isCollapsed]);

    useEffect(() => {
        const handler = (e) => {
            if (window.innerWidth <= 768) return; // no mobile ignora — fica sempre colapsado
            const shouldCollapse = e.detail.collapse;
            setIsCollapsed(shouldCollapse);
            localStorage.setItem(COLLAPSE_KEY, String(shouldCollapse));
        };
        window.addEventListener('sidebar-collapse-request', handler);
        return () => window.removeEventListener('sidebar-collapse-request', handler);
    }, []);

    useEffect(() => {
        const updateScrollbarWidth = () => {
            const el = document.querySelector('.main-content') || document.querySelector('.processing-page');
            const w = el ? el.offsetWidth - el.clientWidth : 0;
            document.documentElement.style.setProperty('--scrollbar-width', w + 'px');
        };
        updateScrollbarWidth();
        window.addEventListener('resize', updateScrollbarWidth);
        const observer = new MutationObserver(updateScrollbarWidth);
        observer.observe(document.body, { childList: true, subtree: false, attributes: true, attributeFilter: ['class'] });
        return () => { window.removeEventListener('resize', updateScrollbarWidth); observer.disconnect(); };
    }, []);

    const toggleCollapse = () => {
        setIsCollapsed(prev => {
            const next = !prev;
            localStorage.setItem(COLLAPSE_KEY, String(next));
            return next;
        });
    };

    const handleLogout = () => {
        localStorage.clear();
        navigate('/');
    };

    const handleNavClick = (view) => {
        setIsMobileOpen(false);
        const route = VIEW_ROUTES[view];
        if (route) {
            navigate(route);
        }
    };

    return (
        <>
            {/* ── Top bar mobile ── */}
            <header className="mobile-topbar">
                <div className="mobile-topbar-brand">
                    <img src={logo} alt="Logo" className="mobile-topbar-logo" />
                    <div className="mobile-topbar-text">
                        <span className="mobile-topbar-title">Vector Tracker</span>
                        <span className="mobile-topbar-municipio">{municipioNome}</span>
                    </div>
                </div>
                <button
                    className="mobile-topbar-hamburger"
                    onClick={() => setIsMobileOpen(o => !o)}
                    aria-label="Menu"
                >
                    <span />
                    <span />
                    <span />
                </button>
            </header>

            {/* Overlay mobile — toque fora fecha a sidebar */}
            {!isCollapsed && (
                <div className="sidebar-overlay" onClick={toggleCollapse} />
            )}

            {/* ── Sidebar ── */}
            <aside className={`sidebar ${isMobileOpen ? 'sidebar--open' : ''} ${isCollapsed ? 'sidebar--collapsed' : ''}`}>
                <div className="sidebar-brand" onClick={toggleCollapse} style={{ cursor: 'pointer' }}>
                    <img src={logo} alt="Logo" className="sidebar-brand-logo" />
                    <div className="sidebar-brand-text">
                        <span className="sidebar-brand-title">Vector Tracker</span>
                        <span className="sidebar-brand-municipio">{municipioNome}</span>
                    </div>
                </div>

                <nav className="sidebar-nav">
                    {navItems.map(({ view, label, icon }) => (
                        <button
                            key={view}
                            data-tooltip={label}
                            onClick={() => handleNavClick(view)}
                            className={`sidebar-nav-item ${activeView === view ? 'active' : ''}`}
                        >
                            <span className="sidebar-nav-icon">{icon}</span>
                            <span className="sidebar-nav-label">{label}</span>
                        </button>
                    ))}
                </nav>

                <div className="sidebar-footer">
                    <button
                        className="sidebar-nav-item sidebar-logout-btn"
                        onClick={handleLogout}
                    >
                        <span className="sidebar-nav-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                                <polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
                            </svg>
                        </span>
                        <span className="sidebar-nav-label">Sair</span>
                    </button>

                    <p className="sidebar-version">© 2026 Vector Tracker v1.0.0</p>
                </div>
            </aside>
        </>
    );
};

export default Sidebar;
